import React from 'react';
import { format } from 'date-fns';

// types
import { Invoice } from '@/services/types/invoice.types';
import { InvoiceCategory, InvoiceStatus } from '@/services/types/enums/invoice.enum';
import { Budget } from '@/services/types/budgets.types';

// icons
import { Ban, CircleXIcon } from 'lucide-react';
import { ReactComponent as CompleteIcon } from '@/assets/icons/completed.svg';
import invoiceImg from '@/assets/images/invoice.png';

interface InvoicePreviewProps {
  invoice: Invoice & { budget?: Budget };
}

const InvoicePreview = ({ invoice }: InvoicePreviewProps) => {
  console.log('invoice', invoice);
  const isExpense = invoice.invoice_category === InvoiceCategory.EXPENSE;
  const status =
    invoice.status === InvoiceStatus.PAID
      ? 'Paid'
      : invoice.status === InvoiceStatus.CANCELLED
        ? 'Cancelled'
        : 'Not Paid';

  return (
    <div className="bg-lightPurple rounded-[16px] p-6 px-0 pt-0">
      <div className="flex flex-col items-center justify-center px-6 pb-4">
        <img src={invoiceImg} alt="invoice-icon" className="inline-block -mt-6 mb-4" />
        <p className={`text-[32px] font-semibold ${isExpense ? 'text-[#DA0041]' : 'text-[#48C80C]'} leading-[115%]`}>
          {isExpense ? '-' : '+'} {invoice.payment_currency === 'EUR' ? '€' : '$'}
          {invoice?.payment_amount?.toLocaleString()}
        </p>
        <p className="text-lg font-semibold">{invoice.name}</p>
        <p className="text-secondary text-sm font-medium">{invoice.budget?.name}</p>
      </div>

      {/* separator */}
      <div className="h-[1px] bg-[#DEE2E6] w-full"></div>

      <div className="pt-4 px-6 space-y-[6px]">
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs text-secondary font-medium">Status</span>

          <div className="flex items-center gap-1">
            <span>
              {invoice?.status === InvoiceStatus.PAID ? (
                <CompleteIcon />
              ) : invoice?.status === InvoiceStatus.CANCELLED ? (
                <Ban className="w-[16px] h-[16px]" />
              ) : (
                <CircleXIcon className="w-[16px] h-[16px]" />
              )}{' '}
            </span>
            <p className="text-sm font-medium">{status}</p>
          </div>
        </div>
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs text-secondary font-medium">Type</span>
          <p className="text-sm font-medium">
            {invoice.invoice_category === InvoiceCategory.EXPENSE ? 'Expense' : 'Revenue'}
          </p>
        </div>
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs text-secondary font-medium">Payment Date</span>
          <p className="text-sm font-medium">
            {invoice?.payment_date ? format(new Date(invoice.payment_date), 'MM/dd/yyyy') : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
